// extracted by mini-css-extract-plugin
export default {"addDrawer":"SelectMarketingMaterialsDrawer_addDrawer__jiTvP","footer":"SelectMarketingMaterialsDrawer_footer__HFXCa"};